import React, {useState, useEffect, useContext, useCallback} from 'react';
import {useApi} from "../api/api-methods";
import UtilsCommon from "../utils/utils.common";
import {useAuth} from "./auth";

const ConversationContext = React.createContext();

const ConversationProvider = ({children}) => {
  const [conversations, setConversations] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const api = useApi();
  const auth = useAuth();

  useEffect(() => {
      (async() => {
        if (!UtilsCommon.authTokenExists() || !auth?.user?.token) return;
        const result = await api.conversation.getLastN().catch(err => []);
        setConversations(result);
      })();
  }, [api]);

  const rename = useCallback(updated => {
    setConversations(cc => cc.map(c => c.id === updated.id ? Object.assign(c, updated) : c));
    void api.conversation.rename(updated.id, updated.summary);
  }, [api]);

  const moveToTop = useCallback(updated => {
    setConversations(cc => [updated, ...cc.filter(c => c.id !== updated.id)]);
  }, []);

  const remove = useCallback(({ id }) => {
    setConversations(cc => cc.filter(c => c.id !== id));
    void api.conversation.delete(id);
  }, [api]);

    return (
        <ConversationContext.Provider value={{ conversations, rename, moveToTop, select: setSelectedId, remove, selectedId }}>
            {children}
        </ConversationContext.Provider>
    );
};

const useConversations = () => useContext(ConversationContext);

export { ConversationContext, ConversationProvider, useConversations };